module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-10-06",
		"endpointPrefix": "codedeploy",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "CodeDeploy",
		"serviceFullName": "AWS CodeDeploy",
		"signatureVersion": "v4",
		"targetPrefix": "CodeDeploy_20141006",
		"timestampFormat": "unixTimestamp",
		"uid": "codedeploy-2014-10-06"
	},
	"operations": {
		"AddTagsToOnPremisesInstances": {
			"input": {
				"type": "structure",
				"required": [
					"tags",
					"instanceNames"
				],
				"members": {
					"tags": {
						"shape": "S2"
					},
					"instanceNames": {
						"shape": "S6"
					}
				}
			}
		},
		"BatchGetApplicationRevisions": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"revisions"
				],
				"members": {
					"applicationName": {},
					"revisions": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"errorMessage": {},
					"revisions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"revisionLocation": {
									"shape": "Sb"
								},
								"genericRevisionInfo": {
									"shape": "Sq"
								}
							}
						}
					}
				}
			}
		},
		"BatchGetApplications": {
			"input": {
				"type": "structure",
				"members": {
					"applicationNames": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applicationsInfo": {
						"type": "list",
						"member": {
							"shape": "Sz"
						}
					}
				}
			}
		},
		"BatchGetDeploymentGroups": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"deploymentGroupNames"
				],
				"members": {
					"applicationName": {},
					"deploymentGroupNames": {
						"shape": "Ss"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentGroupsInfo": {
						"type": "list",
						"member": {
							"shape": "S16"
						}
					},
					"errorMessage": {}
				}
			}
		},
		"BatchGetDeploymentInstances": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentId",
					"instanceIds"
				],
				"members": {
					"deploymentId": {},
					"instanceIds": {
						"shape": "S2g"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instancesSummary": {
						"type": "list",
						"member": {
							"shape": "S2k"
						}
					},
					"errorMessage": {}
				}
			}
		},
		"BatchGetDeployments": {
			"input": {
				"type": "structure",
				"members": {
					"deploymentIds": {
						"shape": "S2x"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentsInfo": {
						"type": "list",
						"member": {
							"shape": "S30"
						}
					}
				}
			}
		},
		"BatchGetOnPremisesInstances": {
			"input": {
				"type": "structure",
				"members": {
					"instanceNames": {
						"shape": "S6"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instanceInfos": {
						"type": "list",
						"member": {
							"shape": "S3e"
						}
					}
				}
			}
		},
		"ContinueDeployment": {
			"input": {
				"type": "structure",
				"members": {
					"deploymentId": {}
				}
			}
		},
		"CreateApplication": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applicationId": {}
				}
			}
		},
		"CreateDeployment": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {},
					"deploymentGroupName": {},
					"revision": {
						"shape": "Sb"
					},
					"deploymentConfigName": {},
					"description": {},
					"ignoreApplicationStopFailures": {
						"type": "boolean"
					},
					"targetInstances": {
						"shape": "S37"
					},
					"autoRollbackConfiguration": {
						"shape": "S1u"
					},
					"updateOutdatedInstancesOnly": {
						"type": "boolean"
					},
					"fileExistsBehavior": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentId": {}
				}
			}
		},
		"CreateDeploymentConfig": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentConfigName"
				],
				"members": {
					"deploymentConfigName": {},
					"minimumHealthyHosts": {
						"shape": "S3o"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentConfigId": {}
				}
			}
		},
		"CreateDeploymentGroup": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"deploymentGroupName",
					"serviceRoleArn"
				],
				"members": {
					"applicationName": {},
					"deploymentGroupName": {},
					"deploymentConfigName": {},
					"ec2TagFilters": {
						"shape": "S19"
					},
					"onPremisesInstanceTagFilters": {
						"shape": "S1c"
					},
					"autoScalingGroups": {
						"shape": "S38"
					},
					"serviceRoleArn": {},
					"triggerConfigurations": {
						"shape": "S1k"
					},
					"alarmConfiguration": {
						"shape": "S1q"
					},
					"autoRollbackConfiguration": {
						"shape": "S1u"
					},
					"deploymentStyle": {
						"shape": "S1x"
					},
					"blueGreenDeploymentConfiguration": {
						"shape": "S20"
					},
					"loadBalancerInfo": {
						"shape": "S28"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentGroupId": {}
				}
			}
		},
		"DeleteApplication": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {}
				}
			}
		},
		"DeleteDeploymentConfig": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentConfigName"
				],
				"members": {
					"deploymentConfigName": {}
				}
			}
		},
		"DeleteDeploymentGroup": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"deploymentGroupName"
				],
				"members": {
					"applicationName": {},
					"deploymentGroupName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"hooksNotCleanedUp": {
						"shape": "S1f"
					}
				}
			}
		},
		"DeregisterOnPremisesInstance": {
			"input": {
				"type": "structure",
				"required": [
					"instanceName"
				],
				"members": {
					"instanceName": {}
				}
			}
		},
		"GetApplication": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"application": {
						"shape": "Sz"
					}
				}
			}
		},
		"GetApplicationRevision": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"revision"
				],
				"members": {
					"applicationName": {},
					"revision": {
						"shape": "Sb"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"revision": {
						"shape": "Sb"
					},
					"revisionInfo": {
						"shape": "Sq"
					}
				}
			}
		},
		"GetDeployment": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentId"
				],
				"members": {
					"deploymentId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentInfo": {
						"shape": "S30"
					}
				}
			}
		},
		"GetDeploymentConfig": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentConfigName"
				],
				"members": {
					"deploymentConfigName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentConfigInfo": {
						"type": "structure",
						"members": {
							"deploymentConfigId": {},
							"deploymentConfigName": {},
							"minimumHealthyHosts": {
								"shape": "S3o"
							},
							"createTime": {
								"type": "timestamp"
							}
						}
					}
				}
			}
		},
		"GetDeploymentGroup": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"deploymentGroupName"
				],
				"members": {
					"applicationName": {},
					"deploymentGroupName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentGroupInfo": {
						"shape": "S16"
					}
				}
			}
		},
		"GetDeploymentInstance": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentId",
					"instanceId"
				],
				"members": {
					"deploymentId": {},
					"instanceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instanceSummary": {
						"shape": "S2k"
					}
				}
			}
		},
		"GetOnPremisesInstance": {
			"input": {
				"type": "structure",
				"required": [
					"instanceName"
				],
				"members": {
					"instanceName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instanceInfo": {
						"shape": "S3e"
					}
				}
			}
		},
		"ListApplicationRevisions": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {},
					"sortBy": {},
					"sortOrder": {},
					"s3Bucket": {},
					"s3KeyPrefix": {},
					"deployed": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"revisions": {
						"shape": "Sa"
					},
					"nextToken": {}
				}
			}
		},
		"ListApplications": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applications": {
						"shape": "Sw"
					},
					"nextToken": {}
				}
			}
		},
		"ListDeploymentConfigs": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentConfigsList": {
						"type": "list",
						"member": {}
					},
					"nextToken": {}
				}
			}
		},
		"ListDeploymentGroups": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"deploymentGroups": {
						"shape": "Ss"
					},
					"nextToken": {}
				}
			}
		},
		"ListDeploymentInstances": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentId"
				],
				"members": {
					"deploymentId": {},
					"nextToken": {},
					"instanceStatusFilter": {
						"type": "list",
						"member": {}
					},
					"instanceTypeFilter": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instancesList": {
						"shape": "S2g"
					},
					"nextToken": {}
				}
			}
		},
		"ListDeployments": {
			"input": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"deploymentGroupName": {},
					"includeOnlyStatuses": {
						"type": "list",
						"member": {}
					},
					"createTimeRange": {
						"type": "structure",
						"members": {
							"start": {
								"type": "timestamp"
							},
							"end": {
								"type": "timestamp"
							}
						}
					},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deployments": {
						"shape": "S2x"
					},
					"nextToken": {}
				}
			}
		},
		"ListGitHubAccountTokenNames": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"tokenNameList": {
						"type": "list",
						"member": {}
					},
					"nextToken": {}
				}
			}
		},
		"ListOnPremisesInstances": {
			"input": {
				"type": "structure",
				"members": {
					"registrationStatus": {},
					"tagFilters": {
						"shape": "S1c"
					},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instanceNames": {
						"shape": "S6"
					},
					"nextToken": {}
				}
			}
		},
		"RegisterApplicationRevision": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"revision"
				],
				"members": {
					"applicationName": {},
					"description": {},
					"revision": {
						"shape": "Sb"
					}
				}
			}
		},
		"RegisterOnPremisesInstance": {
			"input": {
				"type": "structure",
				"required": [
					"instanceName"
				],
				"members": {
					"instanceName": {},
					"iamSessionArn": {},
					"iamUserArn": {}
				}
			}
		},
		"RemoveTagsFromOnPremisesInstances": {
			"input": {
				"type": "structure",
				"required": [
					"tags",
					"instanceNames"
				],
				"members": {
					"tags": {
						"shape": "S2"
					},
					"instanceNames": {
						"shape": "S6"
					}
				}
			}
		},
		"SkipWaitTimeForInstanceTermination": {
			"input": {
				"type": "structure",
				"members": {
					"deploymentId": {}
				}
			}
		},
		"StopDeployment": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentId"
				],
				"members": {
					"deploymentId": {},
					"autoRollbackEnabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"status": {},
					"statusMessage": {}
				}
			}
		},
		"UpdateApplication": {
			"input": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"newApplicationName": {}
				}
			}
		},
		"UpdateDeploymentGroup": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"currentDeploymentGroupName"
				],
				"members": {
					"applicationName": {},
					"currentDeploymentGroupName": {},
					"newDeploymentGroupName": {},
					"deploymentConfigName": {},
					"ec2TagFilters": {
						"shape": "S19"
					},
					"onPremisesInstanceTagFilters": {
						"shape": "S1c"
					},
					"autoScalingGroups": {
						"shape": "S38"
					},
					"serviceRoleArn": {},
					"triggerConfigurations": {
						"shape": "S1k"
					},
					"alarmConfiguration": {
						"shape": "S1q"
					},
					"autoRollbackConfiguration": {
						"shape": "S1u"
					},
					"deploymentStyle": {
						"shape": "S1x"
					},
					"blueGreenDeploymentConfiguration": {
						"shape": "S20"
					},
					"loadBalancerInfo": {
						"shape": "S28"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"hooksNotCleanedUp": {
						"shape": "S1f"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S6": {
			"type": "list",
			"member": {}
		},
		"Sa": {
			"type": "list",
			"member": {
				"shape": "Sb"
			}
		},
		"Sb": {
			"type": "structure",
			"members": {
				"revisionType": {},
				"s3Location": {
					"type": "structure",
					"members": {
						"bucket": {},
						"key": {},
						"bundleType": {},
						"version": {},
						"eTag": {}
					}
				},
				"gitHubLocation": {
					"type": "structure",
					"members": {
						"repository": {},
						"commitId": {}
					}
				}
			}
		},
		"Sq": {
			"type": "structure",
			"members": {
				"description": {},
				"deploymentGroups": {
					"shape": "Ss"
				},
				"firstUsedTime": {
					"type": "timestamp"
				},
				"lastUsedTime": {
					"type": "timestamp"
				},
				"registerTime": {
					"type": "timestamp"
				}
			}
		},
		"Ss": {
			"type": "list",
			"member": {}
		},
		"Sw": {
			"type": "list",
			"member": {}
		},
		"Sz": {
			"type": "structure",
			"members": {
				"applicationId": {},
				"applicationName": {},
				"createTime": {
					"type": "timestamp"
				},
				"linkedToGitHub": {
					"type": "boolean"
				},
				"gitHubAccountName": {}
			}
		},
		"S16": {
			"type": "structure",
			"members": {
				"applicationName": {},
				"deploymentGroupId": {},
				"deploymentGroupName": {},
				"deploymentConfigName": {},
				"ec2TagFilters": {
					"shape": "S19"
				},
				"onPremisesInstanceTagFilters": {
					"shape": "S1c"
				},
				"autoScalingGroups": {
					"shape": "S1f"
				},
				"serviceRoleArn": {},
				"targetRevision": {
					"shape": "Sb"
				},
				"triggerConfigurations": {
					"shape": "S1k"
				},
				"alarmConfiguration": {
					"shape": "S1q"
				},
				"autoRollbackConfiguration": {
					"shape": "S1u"
				},
				"deploymentStyle": {
					"shape": "S1x"
				},
				"blueGreenDeploymentConfiguration": {
					"shape": "S20"
				},
				"loadBalancerInfo": {
					"shape": "S28"
				},
				"lastSuccessfulDeployment": {
					"shape": "S2c"
				},
				"lastAttemptedDeployment": {
					"shape": "S2c"
				}
			}
		},
		"S19": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {},
					"Type": {}
				}
			}
		},
		"S1c": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {},
					"Type": {}
				}
			}
		},
		"S1f": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"name": {},
					"hook": {}
				}
			}
		},
		"S1k": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"triggerName": {},
					"triggerTargetArn": {},
					"triggerEvents": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"S1q": {
			"type": "structure",
			"members": {
				"enabled": {
					"type": "boolean"
				},
				"ignorePollAlarmFailure": {
					"type": "boolean"
				},
				"alarms": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"name": {}
						}
					}
				}
			}
		},
		"S1u": {
			"type": "structure",
			"members": {
				"enabled": {
					"type": "boolean"
				},
				"events": {
					"type": "list",
					"member": {}
				}
			}
		},
		"S1x": {
			"type": "structure",
			"members": {
				"deploymentType": {},
				"deploymentOption": {}
			}
		},
		"S20": {
			"type": "structure",
			"members": {
				"terminateBlueInstancesOnDeploymentSuccess": {
					"type": "structure",
					"members": {
						"action": {},
						"terminationWaitTimeInMinutes": {
							"type": "integer"
						}
					}
				},
				"deploymentReadyOption": {
					"type": "structure",
					"members": {
						"actionOnTimeout": {},
						"waitTimeInMinutes": {
							"type": "integer"
						}
					}
				},
				"greenFleetProvisioningOption": {
					"type": "structure",
					"members": {
						"action": {}
					}
				}
			}
		},
		"S28": {
			"type": "structure",
			"members": {
				"elbInfoList": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"name": {}
						}
					}
				}
			}
		},
		"S2c": {
			"type": "structure",
			"members": {
				"deploymentId": {},
				"status": {},
				"endTime": {
					"type": "timestamp"
				},
				"createTime": {
					"type": "timestamp"
				}
			}
		},
		"S2g": {
			"type": "list",
			"member": {}
		},
		"S2k": {
			"type": "structure",
			"members": {
				"deploymentId": {},
				"instanceId": {},
				"status": {},
				"lastUpdatedAt": {
					"type": "timestamp"
				},
				"lifecycleEvents": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"lifecycleEventName": {},
							"diagnostics": {
								"type": "structure",
								"members": {
									"errorCode": {},
									"scriptName": {},
									"message": {},
									"logTail": {}
								}
							},
							"startTime": {
								"type": "timestamp"
							},
							"endTime": {
								"type": "timestamp"
							},
							"status": {}
						}
					}
				},
				"instanceType": {}
			}
		},
		"S2x": {
			"type": "list",
			"member": {}
		},
		"S30": {
			"type": "structure",
			"members": {
				"applicationName": {},
				"deploymentGroupName": {},
				"deploymentConfigName": {},
				"deploymentId": {},
				"previousRevision": {
					"shape": "Sb"
				},
				"revision": {
					"shape": "Sb"
				},
				"status": {},
				"errorInformation": {
					"type": "structure",
					"members": {
						"code": {},
						"message": {}
					}
				},
				"createTime": {
					"type": "timestamp"
				},
				"startTime": {
					"type": "timestamp"
				},
				"completeTime": {
					"type": "timestamp"
				},
				"deploymentOverview": {
					"type": "structure",
					"members": {
						"Pending": {
							"type": "long"
						},
						"InProgress": {
							"type": "long"
						},
						"Succeeded": {
							"type": "long"
						},
						"Failed": {
							"type": "long"
						},
						"Skipped": {
							"type": "long"
						},
						"Ready": {
							"type": "long"
						}
					}
				},
				"description": {},
				"creator": {},
				"ignoreApplicationStopFailures": {
					"type": "boolean"
				},
				"autoRollbackConfiguration": {
					"shape": "S1u"
				},
				"updateOutdatedInstancesOnly": {
					"type": "boolean"
				},
				"rollbackInfo": {
					"type": "structure",
					"members": {
						"rollbackDeploymentId": {},
						"rollbackTriggeringDeploymentId": {},
						"rollbackMessage": {}
					}
				},
				"deploymentStyle": {
					"shape": "S1x"
				},
				"targetInstances": {
					"shape": "S37"
				},
				"instanceTerminationWaitTimeStarted": {
					"type": "boolean"
				},
				"blueGreenDeploymentConfiguration": {
					"shape": "S20"
				},
				"loadBalancerInfo": {
					"shape": "S28"
				},
				"additionalDeploymentStatusInfo": {},
				"fileExistsBehavior": {}
			}
		},
		"S37": {
			"type": "structure",
			"members": {
				"tagFilters": {
					"shape": "S19"
				},
				"autoScalingGroups": {
					"shape": "S38"
				}
			}
		},
		"S38": {
			"type": "list",
			"member": {}
		},
		"S3e": {
			"type": "structure",
			"members": {
				"instanceName": {},
				"iamSessionArn": {},
				"iamUserArn": {},
				"instanceArn": {},
				"registerTime": {
					"type": "timestamp"
				},
				"deregisterTime": {
					"type": "timestamp"
				},
				"tags": {
					"shape": "S2"
				}
			}
		},
		"S3o": {
			"type": "structure",
			"members": {
				"value": {
					"type": "integer"
				},
				"type": {}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/codedeploy-2014-10-06.min.json
// module id = 1285
// module chunks = 0